import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Download } from "lucide-react";

const lastMonth = () => {
  const d = new Date();
  d.setDate(1);
  d.setMonth(d.getMonth() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export default function ExpenseExport() {
  const [month, setMonth] = useState(lastMonth());
  const [busy, setBusy] = useState("");
  const download = async (fmt) => {
    if (!month) { toast.error("Choisissez un mois"); return; }
    setBusy(fmt);
    try {
      const { data } = await api.get("/expenses-export", { params: { month, fmt }, responseType: "blob" });
      const url = URL.createObjectURL(data);
      const a = document.createElement("a"); a.href = url; a.download = `notes-de-frais-${month}.${fmt}`; a.click(); URL.revokeObjectURL(url);
      toast.success("Export téléchargé");
    } catch { toast.error("Export impossible"); }
    finally { setBusy(""); }
  };
  return (
    <div data-testid="expense-export" className="flex flex-wrap items-end gap-3 rounded-2xl border border-zinc-800 bg-zinc-900 p-4">
      <div className="min-w-0 basis-full sm:basis-auto sm:flex-1">
        <p className="text-sm font-medium text-white">Export comptable</p>
        <p className="text-xs text-zinc-500">Notes validées et remboursées du mois, avec HT, TVA et TTC.</p>
      </div>
      <Input data-testid="expense-export-month" type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="w-44 border-zinc-800 bg-zinc-950 text-white" />
      <Button data-testid="expense-export-xlsx" variant="outline" disabled={!!busy} onClick={() => download("xlsx")} className="rounded-full border-zinc-700 bg-transparent text-white hover:bg-zinc-800">
        <Download className="mr-1 h-4 w-4" />{busy === "xlsx" ? "Export…" : "Excel"}
      </Button>
      <Button data-testid="expense-export-csv" variant="outline" disabled={!!busy} onClick={() => download("csv")} className="rounded-full border-zinc-700 bg-transparent text-white hover:bg-zinc-800">
        <Download className="mr-1 h-4 w-4" />{busy === "csv" ? "Export…" : "CSV"}
      </Button>
    </div>
  );
}
